import handleCart from "./HandleCart";
import { combineReducers } from "redux";

const rootReducers = combineReducers({
  handleCart,
});

export default rootReducers;
